import { ActionType, AppLanguage, FullNamePipe, IAction, LanguageService } from '@aston/foundation';
import { AsyncPipe, CommonModule, NgOptimizedImage, UpperCasePipe } from '@angular/common';
import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { Store } from '@ngrx/store';

import { IAccountInformationModel } from '../../../user-module/models';
import { AppStoreActions } from '../../../root-store/app-store';
import * as RoutesDefinitions from '../../../routes-definitions';
import { AppConfiguration } from '../../../app.configuration';
import { UserService } from '../../../user-module/services';

@Component({
	selector: '[layout-top-bar]',
	templateUrl: './top-bar.component.html',
	imports: [CommonModule, NgOptimizedImage, TranslateModule, NgbDropdownModule, AsyncPipe, UpperCasePipe, FullNamePipe]
})
export class TopBarComponent {
	private languageService = inject(LanguageService);
	private userService = inject(UserService);
	private config = inject(AppConfiguration);
	private store = inject(Store);

	@Input() user: IAccountInformationModel;
	@Input() withThemeSelector: boolean;
	@Input() withAstonLogo: boolean;
	@Input() title: string;
	@Output() action = new EventEmitter<IAction>()

	currentLanguage$ = this.languageService.language$;
	languages = Object.values(AppLanguage);

	assetsPath = this.config.appRootUrl;
	logoutPath: string = RoutesDefinitions.getLogoutFullPath();

	onChangeLanguage(language: AppLanguage) {
		this.languageService.setCurrentLanguage(language)
		firstValueFrom(this.userService.updateUserLanguage(language))
	}

	onToggleThemesPanel(open: boolean = undefined) {
		this.action.emit({ type: ActionType.TOGGLE, value: { name: 'themes', open } })
	}

	logoutConfirmation() {
		const logoutAction = AppStoreActions.Navigate({ to: [RoutesDefinitions.getLogoutFullPath()] })
		this.store.dispatch(AppStoreActions.OpenConfirmationModal({textsKey: `Modal.ConfirmationDeconnexion.`}, logoutAction));
	}
}
